import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/aidf/';

class AidfService {
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (data ? data.token : '')
      };
    });
  }

  findIdfByFiltro(idContribuinte, filtro, situacao, dataIni, dataFin) {
    return axios.get(API_URL + 'allSolicitAidf?idContribuinte=' + idContribuinte + '&filtro=' + filtro + '&situacao=' + situacao + (dataIni ? ('&dataIni=' + dataIni) : "") + (dataFin ? ('&dataFin=' + dataFin) : ""), { headers: this.headers });
  }

  findIdfByFiltroAdmin(idCliente, filtro, situacao, dataIni, dataFin) {
    return axios.get(API_URL + 'allSolicitAidfAdmin?idCliente=' + idCliente + '&filtro=' + filtro + '&situacao=' + situacao + (dataIni ? ('&dataIni=' + dataIni) : "") + (dataFin ? ('&dataFin=' + dataFin) : ""), { headers: this.headers });
  }

  get(aidfId) {
    return axios.get(API_URL + aidfId, { headers: this.headers });
  }

  saveAidf(documentoContr, nomeContr, aidf) {
    return axios.post(API_URL + 'salvarSolicitacao?documentoContr=' + documentoContr + '&nomeContr=' + nomeContr, JSON.stringify(aidf), { headers: this.headers });
  }

  saveSituacaoAidf(id, situacao, observacao) {
    return axios.post(API_URL + 'atualizarAidf?id=' + id + '&situacao=' + situacao + '&observacao=' + observacao, null,
      { headers: this.headers });
  }
}

export default new AidfService();